import { useDispatch } from "react-redux";
import { AppDispatchType } from "../types/dispatch.types";

export const useAppDispatch = () => useDispatch<AppDispatchType>();
